// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profiletabs {
    color: #047E35;
    cursor: pointer
}

.profiletabs::after {
    content: '';
    display: block;
    background-color: #06a847;
    width: 50%;
    height: 7px;
    cursor: pointer
}

.notactivepp {
    cursor: pointer
}

.profiletoppos {
    margin-top: 40px;
}

@media (min-width: 100px) and (max-width: 700px){
    .topprofile {
        margin-top: 20px; 
    }
}

.red-label {
    color: red;
    margin-bottom: '8px';
  }
  
  .flashing-red-label {
    color: red;
    margin-bottom: '8px';
    animation: flash 1s infinite;
  }

  .flash {
    margin-bottom: '8px';
    animation: flash 5s infinite;
  }
  
  @keyframes flash {
    0%, 50%, 100% {
      opacity: 1;
    }
    25%, 75% {
      opacity: 0.5;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/profilepage.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;IACpB,4BAA4B;EAC9B;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,YAAY;IACd;EACF","sourcesContent":[".profiletabs {\n    color: #047E35;\n    cursor: pointer\n}\n\n.profiletabs::after {\n    content: '';\n    display: block;\n    background-color: #06a847;\n    width: 50%;\n    height: 7px;\n    cursor: pointer\n}\n\n.notactivepp {\n    cursor: pointer\n}\n\n.profiletoppos {\n    margin-top: 40px;\n}\n\n@media (min-width: 100px) and (max-width: 700px){\n    .topprofile {\n        margin-top: 20px; \n    }\n}\n\n.red-label {\n    color: red;\n    margin-bottom: '8px';\n  }\n  \n  .flashing-red-label {\n    color: red;\n    margin-bottom: '8px';\n    animation: flash 1s infinite;\n  }\n\n  .flash {\n    margin-bottom: '8px';\n    animation: flash 5s infinite;\n  }\n  \n  @keyframes flash {\n    0%, 50%, 100% {\n      opacity: 1;\n    }\n    25%, 75% {\n      opacity: 0.5;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
